import { Box } from '@mui/material';

import { MarkdownContent } from './markdown-content';

import { TEXT_WRAP_SX } from '../../drive-insights.constants';

type StreamingTextProps = {
  content: string;
  isStreaming?: boolean;
};

export const StreamingText = ({ content }: StreamingTextProps) => {
  return (
    <Box sx={TEXT_WRAP_SX}>
      <MarkdownContent content={content} showCursor={false} />
    </Box>
  );
};
